module.exports = __webpack_public_path__ + "fonts/Gotham-Light.8500f04e.woff";